<section id="levels" class="section reveal reveal--fade-up" s2eReveal aria-labelledby="levels-heading">
  <div class="section__head">
    <div class="section__headings">
      <h2 class="section__title" id="levels-heading">{{ 'levelScale.title' | reportT }}</h2>
      <p class="section__desc">{{ 'levelScale.subtitle' | reportT }}</p>
    </div>
  </div>

  <article class="card level-card" data-print-block>
    <div class="card-content level-scale">
      <!-- Le rail. La largeur d'un palier est sa part de l'intervalle 0–100. -->
      <div class="level-rail">
        <div class="level-rail__marker-layer" aria-hidden="true">
          <div class="level-rail__marker-anchor" [style.--marker.%]="subject().score.percentage">
            <div class="level-marker reveal reveal--fade-down" s2eReveal [revealDelay]="600">
              <span class="level-marker__label"><span>{{ 'levelScale.youAreHere' | reportT }}</span> · <span>{{ subject().score.percentage | reportFmt: 'pct' }}</span></span>
              <svg class="icon level-marker__pin" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"/><circle cx="12" cy="10" r="3"/></svg>
            </div>
          </div>
        </div>

        <div class="level-rail__track" role="img" [attr.aria-label]="'levelScale.title' | reportT">
          @for (band of bands(); track band.code) {
            <div [class]="band.railClass" [style.width.%]="band.width" s2eReveal [revealDelay]="band.railDelay"></div>
          }
        </div>
      </div>

      <!-- Les paliers, énoncés. -->
      <div class="level-bands">
        @for (band of bands(); track band.code) {
          <div [class]="band.bandClass" s2eReveal [revealDelay]="band.bandDelay">
            <div class="level-band__top">
              <span class="level-band__range tabular">{{ 'levelScale.range' | reportT: band.rangeVars }}</span>
              @if (band.active) {
                <span class="level-band__here">{{ 'levelScale.youAreHere' | reportT }}</span>
              }
            </div>
            <!-- Intitulé du plan : il vient de l'API, déjà localisé, et n'est
                 donc pas repassé au moteur i18n. -->
            <p class="level-band__plan">{{ band.planLabel }}</p>
            <p class="level-band__desc">{{ band.descriptionKey | reportT }}</p>
          </div>
        }
      </div>
    </div>
  </article>
</section>
